import axios from "axios";
import { baseURL } from "../utils/consts";

const verifyTransferTicket = async (
  eventId,
  uniqueHash,
  fullName,
  email,
  emailOTP
) => {
  const responseObject = {
    eventId,
    uniqueHash,
    fullName,
    email,
    emailOTP,
  };

  try {
    const response = await axios.post(
      `${baseURL}/invitedVia/expressEntry/verifyTransferTicket`,

      responseObject,

      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.data.payLoad;
    return data;
  } catch (err) {
    throw err;
  }
};

export default verifyTransferTicket;
